import React from "react";
import { useContext } from "react";
import { AccordionContext, useAccordionToggle } from "react-bootstrap";

export const AccordionToggleCustom = ({
  children,
  eventKey,
  callback,
  styleContainer,
  classContainer,
  collapsedStateChildren,
  expandedStateChildren,
  overrideRender,
  ...props
}) => {
  // https://react-bootstrap-v4.netlify.app/components/accordion/#custom-toggle-with-expansion-awareness
  const currentEventKey = useContext(AccordionContext);
  const decoratedOnClick = useAccordionToggle(
    eventKey,
    () => callback && callback(eventKey)
  );
  const isCurrentEventKey = currentEventKey === eventKey;

  return overrideRender ? (
    isCurrentEventKey ? (
      React.cloneElement(expandedStateChildren, { onClick: decoratedOnClick })
    ) : (
      React.cloneElement(collapsedStateChildren, { onClick: decoratedOnClick })
    )
  ) : (
    <button
      style={styleContainer}
      className={classContainer}
      {...props}
      type="button"
      onClick={decoratedOnClick}
    >
      {isCurrentEventKey ? expandedStateChildren : collapsedStateChildren}
    </button>
  );
};
